var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStageConcert14644494(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "m21.376,3.952L14.058.457c-1.282-.611-2.752-.611-4.035,0L2.705,3.952C1.086,4.725.04,6.383.04,8.176l-.04,15.323c0,.275.223.5.499.501h.001c.275,0,.5-.223.5-.499l.009-3.501h21.991v3.5c0,.276.224.5.5.5s.5-.224.5-.5v-15.323c0-1.833-1.005-3.452-2.624-4.225Zm-18.241.902l7.318-3.495c1.009-.48,2.165-.48,3.174,0l7.318,3.495c.556.266,1.013.665,1.358,1.146H1.767c.353-.48.814-.881,1.368-1.146Zm9.365,14.146v-5c0-.156.075-.306.2-.399l.908-.681c.12.052.253.081.392.081.552,0,1-.448,1-1s-.448-1-1-1-1,.448-1,1c0,.038.018.071.022.108l-.922.691c-.376.282-.6.73-.6,1.2v5H1.012l.028-10.823c0-.407.076-.802.203-1.177h2.757v1.5c0,.276.224.5.5.5s.5-.224.5-.5v-1.5h4v1.5c0,.276.224.5.5.5s.5-.224.5-.5v-1.5h4v1.5c0,.276.224.5.5.5s.5-.224.5-.5v-1.5h4v1.5c0,.276.224.5.5.5s.5-.224.5-.5v-1.5h2.809c.12.372.191.766.191,1.177v10.823h-10.5Zm-5.5,3c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h10c.276,0,.5.224.5.5s-.224.5-.5.5H7Zm11,1.5c0,.276-.224.5-.5.5H6.5c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h11c.276,0,.5.224.5.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageConcert14644494);
export default __webpack_public_path__ + "static/media/stage-concert_14644494.2718bd45c27cb71af7ff30965e2ae1f0.svg";
export { ForwardRef as ReactComponent };